/* eslint-disable import/no-default-export */
import { mallApiDomain } from '@/defines/domains'
import { request } from '../request'

export const tpPayApi = {
  async post(path, data) {
    try {
      const url = `${mallApiDomain}/tp_pay${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
